import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import WhatWeSourceSection from './components/WhatWeSourceSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import ContactSection from './components/ContactSection';
import ScrollingTradeRoutes from './components/ScrollingTradeRoutes';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'True Passage Ventures',
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${SITE_URL}/vite.svg`,
    },
    description: 'True Passage Ventures connects global buyers with verified Indian suppliers for material sourcing, OEM manufacturing, export logistics, and custom AI business tools.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CA',
      addressLocality: 'Canada',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: 'English',
      areaServed: 'Worldwide',
    },
    foundingLocation: {
      '@type': 'Place',
      name: 'Canada',
    },
    knowsAbout: [
      'India Sourcing',
      'Global Supply Chain',
      'OEM Manufacturing',
      'Export Logistics',
      'AI Business Tools',
    ],
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'True Passage Ventures',
    url: SITE_URL,
    description: 'Global sourcing and supply chain solutions connecting buyers with verified Indian manufacturers.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/products?filter={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE_URL}/`,
    url: `${SITE_URL}/`,
    name: 'True Passage Ventures – India Sourcing & Global Supply Chain Solutions',
    description: 'True Passage Ventures connects global buyers with verified Indian suppliers for material sourcing, OEM manufacturing, export logistics, and custom AI business tools.',
    isPartOf: { '@id': SITE_URL },
    about: {
      '@type': 'Thing',
      name: 'India Sourcing & Global Supply Chain',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: `${SITE_URL}/`,
        },
      ],
    },
  },
];

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="True Passage Ventures – India Sourcing &amp; Global Supply Chain Solutions"
        description="True Passage Ventures connects global buyers with verified Indian suppliers for material sourcing, OEM manufacturing, export logistics, and custom AI business tools. Get a quote in 24 hours."
        keywords="India sourcing, global supply chain, OEM manufacturing, export logistics, AI business tools, product sourcing India"
        canonical="/"
        schema={homeSchema}
      />
      <Navbar />
      <main className="relative">
        <HeroSection />
        <ScrollingTradeRoutes />
        <div className="relative z-10">
          <WhatWeSourceSection />
          <HowWeWorkSection />
          <ContactSection />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
